export default __webpack_public_path__ + "static/media/profile.2375b400.png";